import { define } from 'wicked-elements'

define('[data-component~="block-content"]', {
  init () {
    this.interviewFormatting()
  },
  connected () {
    
  },
  disconnected () {
    
  },
  interviewFormatting () {
    this.question = this.element.querySelector('[data-question]')
    this.answer = this.element.querySelector('[data-answer]')
    if (this.question) this.question.classList.add('open')
    if (this.answer) this.answer.classList.add('open')
  }
})